var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { bordered: false, shadow: "never" },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "admin:agreement:user:info",
                        "admin:agreement:userprivacy:info",
                        "admin:agreement:useraccountcancel:info",
                        "admin:agreement:useraccountcancelnotice:info",
                        "admin:agreement:aboutus:info",
                        "admin:agreement:intelligent:info",
                        "admin:agreement:coupon:agreement:info",
                      ],
                      expression:
                        "[\n                'admin:agreement:user:info',\n                'admin:agreement:userprivacy:info',\n                'admin:agreement:useraccountcancel:info',\n                'admin:agreement:useraccountcancelnotice:info',\n                'admin:agreement:aboutus:info',\n                'admin:agreement:intelligent:info',\n                'admin:agreement:coupon:agreement:info',\n            ]",
                    },
                  ],
                  attrs: { "tab-position": "left" },
                  on: { "tab-click": _vm.tabStatus },
                  model: {
                    value: _vm.agreementValue,
                    callback: function ($$v) {
                      _vm.agreementValue = $$v
                    },
                    expression: "agreementValue",
                  },
                },
                _vm._l(_vm.tabList, function (item, index) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: index,
                      attrs: { label: item.title, name: item.info },
                    },
                    [
                      _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "phoneBox" }, [
                          _c("div", {
                            staticClass: "fontBox",
                            domProps: {
                              innerHTML: _vm._s(_vm.formValidate.agreement),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ueditor" },
                          [
                            _c("div", { staticClass: "font" }, [
                              _c("span", { staticClass: "verticalLine" }),
                              _vm._v(" " + _vm._s(item.title)),
                            ]),
                            _vm._v(" "),
                            _c("Tinymce", {
                              key: _vm.keyIndex,
                              model: {
                                value: _vm.formValidate.agreement,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "agreement", $$v)
                                },
                                expression: "formValidate.agreement",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "admin:agreement:user:save",
                            "admin:agreement:userprivacy:save",
                            "admin:agreement:useraccountcancel:save",
                            "admin:agreement:useraccountcancelnotice:save",
                            "admin:agreement:aboutus:save",
                            "admin:agreement:intelligent:save",
                            "admin:agreement:coupon:agreement:save",
                          ],
                          expression:
                            "[\n                    'admin:agreement:user:save',\n                    'admin:agreement:userprivacy:save',\n                    'admin:agreement:useraccountcancel:save',\n                    'admin:agreement:useraccountcancelnotice:save',\n                    'admin:agreement:aboutus:save',\n                    'admin:agreement:intelligent:save',\n                    'admin:agreement:coupon:agreement:save',\n                ]",
                        },
                      ],
                      staticClass: "button",
                      attrs: { type: "primary" },
                      on: { click: _vm.submenus },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }